<div class="dialog-wrapper">
  <button class="close-btn" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>

  <!-- CONFIRM STATE -->
  <div *ngIf="state === 'CONFIRM'">
    <div class="dialog-content">
      <div class="icon-container">
        <div class="icon-bg warning-bg">
          <mat-icon class="warning-icon">error_outline</mat-icon>
        </div>
      </div>
      <div class="text-container">
        <h2 class="dialog-title">¿Deseas eliminar esta incidencia?</h2>
        <p class="dialog-text">
          Si eliminas esta incidencia, se eliminará en este listado y en la
          Biblia.
          <strong>Esta acción no se puede deshacer.</strong>
        </p>
      </div>
    </div>
    <div class="actions-container">
      <button
        class="buttonPrimary"
        style="background-color: #f06126"
        (click)="deleteOpIncident()"
      >
        Eliminar
      </button>
      <button class="buttonSecundary" (click)="closeDialog()">Cancelar</button>
    </div>
  </div>

  <!-- LOADING STATE -->
  <div *ngIf="state === 'LOADING'" class="loading-state">
    <mat-spinner diameter="40"></mat-spinner>
    <p class="dialog-text" style="margin-top: 16px">Eliminando...</p>
  </div>

  <!-- SUCCESS STATE -->
  <div *ngIf="state === 'SUCCESS'">
    <div class="dialog-content">
      <div class="icon-container">
        <div class="icon-bg success-bg">
          <mat-icon class="success-icon">check_circle_outline</mat-icon>
        </div>
      </div>
      <div class="text-container">
        <h2 class="dialog-title">Eliminado correctamente</h2>
        <p class="dialog-text">
          La incidencia <strong>"{{ data.opIncidentType }}"</strong> fue
          eliminada correctamente de Incidencias y Biblia.
        </p>
      </div>
    </div>
    <div class="actions-container">
      <button
        class="buttonPrimary"
        style="background-color: #f06126"
        (click)="closeDialog(true)"
      >
        Aceptar
      </button>
    </div>
  </div>

  <!-- ERROR STATE -->
  <div *ngIf="state === 'ERROR'">
    <div class="dialog-content">
      <div class="icon-container">
        <div class="icon-bg error-bg">
          <mat-icon class="error-icon">highlight_off</mat-icon>
        </div>
      </div>
      <div class="text-container">
        <h2 class="dialog-title">Error al eliminar incidencia</h2>
        <p class="dialog-text">
          No se pudo eliminar la incidencia registrada.<br />
          <strong>Inténtalo nuevamente.</strong>
        </p>
      </div>
    </div>
    <div class="actions-container">
      <button
        class="buttonPrimary"
        style="background-color: #f06126"
        (click)="deleteOpIncident()"
      >
        Reintentar
      </button>
    </div>
  </div>
</div>
